// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileZipTwoToneSvg from "@ant-design/icons-svg/es/asn/FileZipTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileZipTwoTone = function FileZipTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileZipTwoToneSvg
  }));
};

FileZipTwoTone.displayName = 'FileZipTwoTone';
export default React.forwardRef(FileZipTwoTone);